import { Query } from 'graphql/generated/graphqlTypes';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';

export function mockedGetAllVisitorsWithoutNestedResolversData(
  getVisitors: Query['getVisitors']
): Pick<Query, 'getVisitors'> {
  return { getVisitors };
}

// Must match the full visitor list GET_ALL_VISITORS_FOR_TENANT uses (mockVisitorsWithGroups) — this
// query warms the cache that the composed cache-only read later relies on, so any visitor missing
// here (e.g. mockVisitor15WithoutGroup) silently disappears from the Users overview table.
export const mockedGetAllVisitorsWithoutNestedResolversDataForQuery =
  mockedGetAllVisitorsWithoutNestedResolversData(mockVisitorsWithGroups);
